import {
  GET_NOTATION_HEADER,
  GET_NOTATION_RAW,
  GET_NOTATION_WXR,
  GET_JOURNALIST_BONUS,
  UPDATE_JOURNALIST_BONUS,
  GET_NOTATION_COMPARE,
  GET_NOTATION_HEADER_COMPARE,
  GET_NOTATION_COMPARE_ADDITIONAL_RIVALS
} from '../constants/notes';

const DEFAULT_STATE = {
  header: {},
  raw: [],
  wxr: {
    filters: { classements: [], appellations: [], vintages: [], colors: [] }
  },
  journalistBonus: [],
  compare: {
    wxr_history: []
  },
  additionalRivals: {},
  headerCompare: {}
};

export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case GET_NOTATION_HEADER:
      return { ...state, header: action.payload };
    case GET_NOTATION_HEADER_COMPARE:
      return { ...state, headerCompare: action.payload };
    case GET_NOTATION_RAW:
      return { ...state, raw: action.payload };
    case GET_NOTATION_WXR:
      return { ...state, wxr: action.payload };
    case GET_JOURNALIST_BONUS:
      return {
        ...state,
        journalistBonus: action.payload ? action.payload : []
      };
    case UPDATE_JOURNALIST_BONUS:
      let newJournalistBonus = [...state.journalistBonus];
      const newBonus = action.payload;
      const currentBonus = newJournalistBonus.find(
        (journalist) => journalist.journalist === newBonus.journalist
      );
      if (currentBonus) {
        newJournalistBonus = newJournalistBonus.map((journalist) =>
          journalist.journalist === newBonus.journalist ? newBonus : journalist
        );
      } else {
        newJournalistBonus.push(newBonus);
      }
      return { ...state, journalistBonus: newJournalistBonus };
    case GET_NOTATION_COMPARE:
      return { ...state, compare: action.payload };
    case GET_NOTATION_COMPARE_ADDITIONAL_RIVALS:
      return { ...state, additionalRivals: action.payload };

    default:
      return state;
  }
};
